import { NazioneDTO } from "./nazione.dto";

export class BonificoExtraSepaDTO {
	istitutoBancario: string;
	numeroConto: string;
	indirizzo: string;
	localita: string;
	//TODO
	// nazione: string;
	nazione: NazioneDTO;
}